<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <h2>
          <v-icon class="mr-2" size="28" >
            mdi-home-import-outline
          </v-icon>
          処分場受入
        </h2>
      </v-col>
    </v-row>
    <!-- ステータスボタン -->
    <v-row>
      <v-col cols="12" md="6">
        <v-item-group v-model="conditions.selected_status" @change="statusChangeEvent">
          <v-row>
            <!-- 受入予定 -->
            <v-col>
              <v-item
                v-slot="{ active, toggle }"
                value="receive_plan"
              >
                <v-card
                  :color="active ? 'primary-gradients' : ''"
                  class="rounded-card"
                  @click="toggle"
                >
                  <v-card-text>
                    <v-row class="status-card">
                      <v-col
                        v-if="$vuetify.breakpoint.mdAndUp"
                        cols="12"
                        md="7"
                        class="image-col"
                      >
                        <v-layout :justify-center="true">
                          <v-img
                            max-height="90"
                            aspect-ratio="1"
                            contain
                            :src="require(`@/assets/images/order/receive_statuses/receive_plan.png`)"
                          />
                        </v-layout>
                      </v-col>
                      <v-col
                        cols="12"
                        md="5"
                        class="status-col"
                      >
                        <div
                          class="fill-width"
                          :class="active ? 'white--text' : ''"
                        >
                          <div
                            class="text-center font-weight-bold"
                            :class="$vuetify.breakpoint.xlOnly ? '' : 'to-small-font'"
                          >
                            <span :style="`line-height: ${$vuetify.breakpoint.smAndUp ? 3 : 1}`">受入予定</span>
                          </div>
                          <div class="text-center">
                            <span class="text-h5 font-weight-bold">
                              {{ summaries.receive_plan }}
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /受入予定 -->

            <!-- 受入完了 -->
            <v-col>
              <v-item
                v-slot="{ active, toggle }"
                value="receive_completed"
              >
                <v-card
                  :color="active ? 'primary-gradients' : ''"
                  class="rounded-card"
                  @click="toggle"
                >
                  <v-card-text>
                    <v-row
                      class="status-card"
                    >
                      <v-col
                        v-if="$vuetify.breakpoint.mdAndUp"
                        cols="12"
                        md="7"
                        class="image-col"
                      >
                        <v-layout
                          :justify-center="true"
                        >
                          <v-img
                            max-height="90"
                            aspect-ratio="1"
                            contain
                            :src="require(`@/assets/images/order/receive_statuses/receive_completed.png`)"
                          />
                        </v-layout>
                      </v-col>
                      <v-col
                        cols="12"
                        md="5"
                        class="status-col"
                      >
                        <div
                          class="fill-width"
                          :class="active ? 'white--text' : ''"
                        >
                          <div
                            class="text-center font-weight-bold"
                            :class="$vuetify.breakpoint.xlOnly ? '' : 'to-small-font'"
                          >
                            <span :style="`line-height: ${$vuetify.breakpoint.smAndUp ? 3 : 1}`">受入完了</span>
                          </div>
                          <div class="text-center">
                            <span class="text-h5 font-weight-bold">
                              {{ summaries.receive_completed }}
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /受入完了 -->

            <!-- 処分完了 -->
            <v-col>
              <v-item
                v-slot="{ active, toggle }"
                value="disposal_completed"
              >
                <v-card
                  :color="active ? 'primary-gradients' : ''"
                  class="rounded-card"
                  @click="toggle"
                >
                  <v-card-text>
                    <v-row
                      class="status-card"
                    >
                      <v-col
                        v-if="$vuetify.breakpoint.mdAndUp"
                        cols="12"
                        md="7"
                        class="image-col"
                      >
                        <v-layout
                          :justify-center="true"
                        >
                          <v-img
                            max-height="90"
                            aspect-ratio="1"
                            contain
                            :src="require(`@/assets/images/order/receive_statuses/disposal_completed.png`)"
                          />
                        </v-layout>
                      </v-col>
                      <v-col
                        cols="12"
                        md="5"
                        class="status-col"
                      >
                        <div
                          class="fill-width"
                          :class="active ? 'white--text' : ''"
                        >
                          <div
                            class="text-center font-weight-bold"
                            :class="$vuetify.breakpoint.xlOnly ? '' : 'to-small-font'"
                          >
                            <span :style="`line-height: ${$vuetify.breakpoint.smAndUp ? 3 : 1}`">処分完了</span>
                          </div>
                          <div class="text-center">
                            <span class="text-h5 font-weight-bold">
                              {{ summaries.disposal_completed }}
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /処分完了 -->
          </v-row>
        </v-item-group>
      </v-col>
    </v-row>
    <!-- /ステータスボタン -->

    <!-- 絞り込み検索 -->
    <v-row>
      <v-col>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <!-- 受注番号, 受入日（From）, 受入日（To） -->
                  <v-row>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="conditions.order_number"
                        background-color="white"
                        dense
                        hide-details="auto"
                        label="受注番号"
                        outlined
                        rounded
                        persistent-placeholder
                        clearable
                        style="font-size: 80%"
                        @blur="searchButtonClickEvent()"
                        @click:clear="conditions.order_number = null; searchButtonClickEvent()"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <cs-date-picker
                        :date.sync="conditions.carry_in_start_date"
                        @dateChangedCallback="carryInStartDateChangedCallback"
                      >
                        <template v-slot="{ on, attrs }">
                          <v-text-field
                            v-model="conditions.carry_in_start_date"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar"
                            clearable
                            dense
                            hide-details="auto"
                            label="受入日（From）"
                            outlined
                            persistent-placeholder
                            placeholder="日付を選択"
                            readonly
                            rounded
                            style="font-size: 80%"
                            @click:clear="conditions.carry_in_start_date = null; searchButtonClickEvent()"
                          >
                            <template v-slot:append-outer>
                              <div
                                v-if="$vuetify.breakpoint.mdAndUp"
                                style="vertical-align: middle"
                              >
                                〜
                              </div>
                            </template>
                          </v-text-field>
                        </template>
                      </cs-date-picker>
                    </v-col>
                    <v-col cols="12" md="2">
                      <cs-date-picker
                        :date.sync="conditions.carry_in_end_date"
                        @dateChangedCallback="carryInEndDateChangedCallback"
                      >
                        <template v-slot="{ on, attrs }">
                          <v-text-field
                            v-model="conditions.carry_in_end_date"
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar"
                            clearable
                            dense
                            hide-details="auto"
                            label="受入日（To）"
                            outlined
                            persistent-placeholder
                            placeholder="日付を選択"
                            readonly
                            rounded
                            style="font-size: 80%"
                            @click:clear="conditions.carry_in_end_date = null; searchButtonClickEvent()"
                          />
                        </template>
                      </cs-date-picker>
                    </v-col>
                  </v-row>
                  <!-- /受注番号, 受入日（From）, 受入日（To） -->

                  <!-- 搬入業者（排出） -->
                  <v-row>
                    <v-col cols="12" md="4">
                      <infinite-emission-auto-complete
                        :supplier-id="conditions.supplier_id"
                        classes="search-font"
                        rounded
                        label="搬入業者（排出）"
                        uncontrol-disabled
                        @update:values="supplierChangedCallback"
                      >
                        <template v-slot:append-outer>
                          <v-btn
                            color="primary"
                            small
                            @click="emissionDialogButtonClickEvent"
                          >
                            排出事業者を選択
                          </v-btn>
                          <choose-emission-modal
                            :enable="enableEmissionDialog"
                            @selected="choseSupplierCallback"
                            @close="dialogCloseCallback"
                          />
                        </template>
                      </infinite-emission-auto-complete>
                    </v-col>
                  <!-- /搬入業者（排出） -->

                  <!-- 搬入業者（収運） -->
                    <v-col cols="12" md="4">
                      <infinite-trader-auto-complete
                        :trader-id="conditions.trader_id"
                        :without-none-reporting="true"
                        :without-none-subscribe="false"
                        classes="search-font"
                        label="搬入業者（収運）"
                        rounded
                        with-none-location
                        @update:values="traderChangedCallback"
                      >
                        <template v-slot:append-outer>
                          <v-btn
                            color="primary"
                            small
                            @click="traderDialogButtonClickEvent"
                          >
                            収運業者を選択
                          </v-btn>
                          <choose-trader-modal
                            :enable="enableTraderDialog"
                            :without-non-reporting="true"
                            :without-non-subscribe="false"
                            search-type="transport"
                            with-none-location
                            @selected="choseTraderCallback"
                            @close="dialogCloseCallback"
                          />
                        </template>
                      </infinite-trader-auto-complete>
                    </v-col>
                  </v-row>
                  <!-- 搬入業者（収運） -->

                  <!-- 処分事業場,  -->
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-autocomplete
                        v-model="conditions.disposal_location_id"
                        :disabled="disposalLocations.length <= 1"
                        :items="disposalLocations"
                        class="search-font"
                        clearable
                        dense
                        hide-details="auto"
                        label="処分事業場"
                        outlined
                        persistent-placeholder
                        rounded
                        @change="searchButtonClickEvent"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="conditions.sort_type"
                        :items="sortTypes"
                        class="search-font"
                        dense
                        hide-details="auto"
                        label="表示順"
                        outlined
                        persistent-placeholder
                        rounded
                        @change="searchButtonClickEvent"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    @click="searchButtonClickEvent"
                  >
                    <v-icon>
                      mdi-magnify
                    </v-icon>
                    &nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- /絞り込み検索 -->

    <!-- CSV出力ボタン -->
    <v-row>
      <v-col class="text-right">
        <v-btn
          class="info"
          @click="outputCsvButtonClickEvent"
        >
          &emsp;CSV出力&emsp;
        </v-btn>
      </v-col>
    </v-row>
    <!-- /CSV出力ボタン -->

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>

    <!-- 一覧 -->
    <v-row>
      <v-col>
        <v-sheet rounded>
          <v-data-table
            v-model="rowSelected"
            :headers="tableHeaders"
            :items="acceptances"
            :items-per-page="-1"
            disable-sort
            hide-default-footer
            show-select
            checkbox-color="#DCDCDC"
            @click:row="toggleRowSelection"
          >
            <!-- ステータス -->
            <template v-slot:[`item.status`]="{ item }">
              <v-chip
                x-small
                label
                dark
                :color="item.status | order_receive_status_chip_color"
              >
                {{ item.status | order_receive_status_name }}
              </v-chip>
            </template>
            <!-- /ステータス -->

            <!-- 受注番号/受入番号 -->
            <template v-slot:[`item.order_no`]="{ item }">
              <div>
                  <span v-if="item.order_no">
                    {{ item.order_no }}
                  </span>
                <span v-else>
                    -
                  </span>
              </div>
              <div>
                  <span v-if="item.carrying_no">
                    {{ item.carrying_no }}
                  </span>
                <span v-else>
                    -
                  </span>
              </div>
            </template>
            <!-- /受注番号/受入番号 -->

            <!-- 搬入予定日/予定時間 -->
            <template v-slot:[`item.carrying_plan_date`]="{ item }">
              <div>
                {{ item.carrying_plan_date | date_format }}&nbsp;
              </div>
              <div v-if="item.order_type === 'carryin'">
                {{ item.carrying_plan_start_time | from_to_linked_time(item.carrying_plan_end_time, ' 〜 ') }}
              </div>
            </template>
            <!-- /搬入予定日/予定時間 -->
            <!-- 搬入業者 -->
            <template v-slot:[`item.trader`]="{ item }">
              <div
                v-if="item.trader"
                :title="item.trader.name"
                class="line-clamp one-clamp"
              >
                {{ item.trader.name }}
              </div>
            </template>
            <!-- /搬入業者 -->

            <!-- 処分場/排出業者 -->
            <template v-slot:[`item.disposer`]="{ item }">
              <div style="clear: both;">
                <template v-if="item.disposer.name">
                  <div
                    :title="item.disposer.name"
                    class="line-clamp one-clamp float-left"
                    style="max-width: 76%;width: auto;"
                  >
                    {{ item.disposer.name }}
                  </div>
                </template>
                <div v-else>
                  -
                </div>
                <span v-if="item.disposer.name && item.total_disposal_location_count > 0">
                    &emsp;全&nbsp;{{ item.total_disposal_location_count }}件
                  </span>
              </div>
              <div style="clear: both;">
                <div v-if="item.emission.name">
                  <div
                    :title="item.emission.name"
                    class="line-clamp one-clamp float-left"
                    style="max-width: 76%;width: auto"
                  >
                    {{ item.emission.name }}
                  </div>

                </div >
                <div v-else>
                  -
                </div>
                <span v-if="item.emission.name && item.total_emission_count > 0">
                    &emsp;全&nbsp;{{ item.total_emission_count }}件
                  </span>
              </div>
            </template>
            <!-- /処分場//排出業者 -->

            <!-- 品目/荷姿 -->
            <template v-slot:[`item.item`]="{ item }">
              <div>
                <v-chip
                  v-if="item.item_name"
                  :title="item.item_name"
                  color="#F0E6D0"
                  drak
                  label
                  x-small
                >
                  {{ item.item_name | truncate(10) }}
                </v-chip>
                <span v-else>&emsp;</span>
              </div>
              <small>{{ item.packing_name }}</small>
              <small><span v-if="item.total_items_count > 0">&emsp;全&nbsp;{{ item.total_items_count }}件</span></small>
            </template>
            <!-- /品目/荷姿 -->

            <!-- マニフェスト -->
            <template v-slot:[`item.manifest`]="{ item }">
              <small>{{ item.manifest_no }}<span v-if="item.total_manifests_count > 0">&emsp;全&nbsp;{{ item.total_manifests_count }}件</span></small>
            </template>
            <!-- /マニフェスト -->

            <!-- 中間処分日/最終処分日 -->
            <template v-slot:[`item.disposal_date`]="{ item }">
              <div>
                  <span>
                  {{ item.disposal_end_middle_at || '-' }}&nbsp;
                  </span>
              </div>
              <div>
                  <span>
                  {{ item.disposal_end_last_at || '-' }}&nbsp;
                  </span>
              </div>
            </template>
            <!-- /中間処分日/最終処分日 -->

            <template v-slot:[`item.editable`]="{ item }">
              <v-menu
                bottom
                left
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-dots-horizontal</v-icon>
                  </v-btn>
                </template>
                {{ item.name }}
                <v-list dense>
                  <v-list-item
                    link
                    @click="showButtonClickEvent(item)"
                  >
                    <v-list-item-title>
                      詳細を参照
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="item.can_directly_complete"
                    link
                    @click="directlyCompleteButtonClickEvent(item)"
                  >
                    <v-list-item-title> 登録完了にする </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <!-- フッター -->
            <template v-slot:footer>
            </template>
            <!-- /フッター -->
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <!-- /一覧 -->

    <!-- ページャ -->
    <v-row class="mb-15">
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->

    <v-footer fixed class="mb-13" color="white" width="100%" style="overflow-x: auto;">
      <v-card flat width="100%">
        <v-card-actions>
          <v-spacer />
          <template>
            <!-- 受渡確認票出力 -->
            <v-btn
              color="info"
              class="mr-3"
              :disabled="rowSelected.length <= 0"
              @click="outputManifestButtonClickEvent"
            >
              受渡確認票出力
            </v-btn>
            <!-- /受渡確認票出力 -->
            <v-btn
              color="primary"
              class="mr-3"
              :disabled="rowSelected.length <= 0"
              @click="receiveRegisterButtonClickEvent"
            >
              受入登録
            </v-btn>
            <v-menu :disabled="rowSelected.length <= 0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="rowSelected.length <= 0"
                  class="mr-3"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  処分終了報告
                </v-btn>
              </template>
              <v-list>
                <v-list-item link @click="disposalReportDialogClickEvent(true)">
                  <v-list-item-title> 個別登録(再資源) </v-list-item-title>
                </v-list-item>
                <v-list-item link @click="bulkDisposalReportDialogClickEvent(true)">
                  <v-list-item-title> 一括登録(再資源) </v-list-item-title>
                </v-list-item>
                <v-divider v-if="!isRecycling"></v-divider>
                <v-list-item v-if="!isRecycling" link @click="disposalReportDialogClickEvent(false)">
                <v-list-item-title> 個別登録 </v-list-item-title>
              </v-list-item>
              <v-list-item  v-if="!isRecycling" link @click="bulkDisposalReportDialogClickEvent(false)">
                <v-list-item-title> 一括登録 </v-list-item-title>
              </v-list-item>
              </v-list>
            </v-menu>
            <v-menu :disabled="rowSelected.length <= 0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="rowSelected.length <= 0"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  最終処分終了報告
                </v-btn>
              </template>
              <v-list>
                <v-list-item link @click="finalDisposalReportDialogClickEvent('recycle')">
                  <v-list-item-title>
                    個別登録(再資源)
                  </v-list-item-title>
                </v-list-item>
                <v-list-item link @click="bulkFinalDisposalReportDialogClickEvent('recycle')">
                  <v-list-item-title>
                    一括登録(再資源)
                  </v-list-item-title>
                </v-list-item>
                <v-divider v-if="!isRecycling"></v-divider>
                <v-list-item @click="finalDisposalReportDialogClickEvent('default')">
                  <v-list-item-title>
                    {{ !isRecycling ? '個別登録' : '個別登録(紙のみ)' }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="bulkFinalDisposalReportDialogClickEvent('default')">
                  <v-list-item-title>
                    {{ !isRecycling ? '一括登録' : '一括登録(紙のみ)' }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-card-actions>
      </v-card>
    </v-footer>

    <!-- 処分終了報告(個別) -->
    <disposal-report-dialog
      :enable-dialog="enableDisposalReportDialog"
      :order-ids="selectedOrderIds"
      :manifest-ids="targetManifestIds"
      :manifest-level="conditions.type_of_manifest"
      :sort-type="conditions.sort_type"
      :show-recycling-fields="showRecyclingFields"
      @cancelCallback="dialogCloseCallback"
      @registerEvent="editDialogRegisterCallback"
    />
    <!-- /処分終了報告(個別) -->
    <!-- 処分終了報告(一括) -->
    <bulk-disposal-report-dialog
      :enable-dialog="enableBulkDisposalReportDialog"
      type="Acceptance"
      :order-ids="selectedOrderIds"
      :manifest-ids="targetManifestIds"
      :show-recycling-fields="showRecyclingFields"
      @cancelCallback="dialogCloseCallback"
      @registerEvent="editDialogRegisterCallback"
    />
    <!-- /処分終了報告(一括) -->
    <!-- 最終処分終了報告(個別) -->
    <final-disposal-report-dialog
      :enable-dialog="enableFinalDisposalReportDialog"
      type="Acceptance"
      :order-ids="selectedOrderIds"
      :manifest-ids="targetManifestIds"
      :sort-type="conditions.sort_type"
      @cancelCallback="dialogCloseCallback"
      @registerEvent="editDialogRegisterCallback"
    />
    <!-- /最終処分終了報告(個別) -->
    <!-- 最終処分終了報告(一括) -->
    <bulk-final-disposal-report-dialog
      :enable-dialog="enableBulkFinalDisposalReportDialog"
      type="Acceptance"
      :order-ids="selectedOrderIds"
      :manifest-ids="targetManifestIds"
      @cancelCallback="dialogCloseCallback"
      @registerEvent="editDialogRegisterCallback"
    />
    <!-- /最終処分終了報告(一括) -->

    <recycle-final-disposal-report-dialog
      :enable-dialog="enableRecycleFinalDisposalReportDialog"
      type="Acceptance"
      :order-ids="selectedOrderIds"
      :manifest-ids="targetManifestIds"
      :sort-type="conditions.sort_type"
      @cancelCallback="dialogCloseCallback"
      @registerEvent="editDialogRegisterCallback"
    />
    <bulk-recycle-final-disposal-report-dialog
      :enable-dialog="enableBulkRecycleFinalDisposalReportDialog"
      type="Acceptance"
      :order-ids="selectedOrderIds"
      :manifest-ids="targetManifestIds"
      @cancelCallback="dialogCloseCallback"
      @registerEvent="editDialogRegisterCallback"
    />
    <v-dialog
      v-model="enableWarningDialog"
      persistent
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 red darken-2 white--text">
          確認
        </v-card-title>
        <v-divider />
        <v-card-text>
          <h4 class="mt-4">
            {{ warningDialogMessage }}
          </h4>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="enableWarningDialog = false"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="enableWarningDialog2" persistent width="500">
      <v-card>
        <v-card-title class="text-h5 red darken-2 white--text">
          確認
        </v-card-title>
        <v-divider />
        <v-card-text>
          <h4 class="mt-4">
            {{ warningDialogMessage2 }}
          </h4>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn @click="enableWarningDialog2 = false"> 閉じる </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>

import {mapActions, mapState} from 'vuex'
import Confirm from '@/components/Confirm'
import DisposalReportDialog from '../dialogs/_DisposalReportDialog'
import BulkDisposalReportDialog from '../dialogs/_BulkDisposalReportDialog'
import FinalDisposalReportDialog from '../dialogs/_FinalDisposalReportDialog'
import BulkFinalDisposalReportDialog from '../dialogs/_BulkFinalDisposalReportDialog'
import DownloadMixin from '../../../mixins/download-mixin'
import CustomPagination from "@/driver/components/_CustomPagination.vue";

import InfiniteEmissionAutoComplete from "@/driver/components/InfiniteEmissionAutoComplete.vue";
import ChooseEmissionModal from "@/driver/components/ChooseEmissionModal.vue";
import InfiniteTraderAutoComplete from "@/driver/components/InfiniteTraderAutoComplete.vue";
import ChooseTraderModal from "@/driver/components/ChooseTraderModal.vue";
import RecycleFinalDisposalReportDialog from "@/driver/pages/dialogs/_RecycleFinalDisposalReportDialog.vue";
import BulkRecycleFinalDisposalReportDialog from "@/driver/pages/dialogs/_BulkRecycleFinalDisposalReportDialog.vue";

export default {
  name: 'DriverAcceptances',
  components: {
    BulkRecycleFinalDisposalReportDialog,
    RecycleFinalDisposalReportDialog,
    ChooseTraderModal,
    InfiniteTraderAutoComplete,
    ChooseEmissionModal,
    InfiniteEmissionAutoComplete,
    CustomPagination,
    Confirm,
    DisposalReportDialog,
    BulkDisposalReportDialog,
    FinalDisposalReportDialog,
    BulkFinalDisposalReportDialog,
  },
  mixins: [
  DownloadMixin,
  ],
  props: {},
  data() {
    return {
      page: 1,
      perPage: 50,
      totalVisible: 7,
      enableEmissionDialog: false,
      enableTraderDialog: false,
      enableDisposalReportDialog: false,
      enableBulkDisposalReportDialog: false,
      enableFinalDisposalReportDialog: false,
      enableBulkFinalDisposalReportDialog: false,
      enableRecycleFinalDisposalReportDialog: false,
      enableBulkRecycleFinalDisposalReportDialog: false,
      selectedStatus: null,
      showRecyclingFields: false,
      conditions: {
        selected_status: null,
        order_number: null,
        supplier_id: null,
        supplier_type: "Emission",
        trader_id: null,
        trader_type: "Trader",
        carry_in_start_date: null,
        carry_in_end_date: null,
        disposal_location_id: null,
        sort_type: "updated_date_desc",
      },
      searchForms: {
        orderNumber: null,
        traderId: null,
        traderType: null,
        traderName: null,
        carryInStartDate: null,
        carryInEndDate: null,
        disposalLocationId: null,
        sortType: 'updated_date_desc',
      },
      summaries: {},
      tableHeaders: [
        { value: 'status', text: 'ステータス', width: '5%' },
        { value: 'order_no', text: '受注番号\r\n受入番号', align: 'center', width: '6%' },
        { value: 'carrying_plan_date', text: '受入日（予定日)\r\n予定時間', align: 'center', width: '10%' },
        { value: 'trader', text: '搬入業者', width: '22%' },
        { value: 'disposer', text: '処分場\r\n排出事業者', width: '24%' },
        { value: 'item', text: '取扱品目\r\n荷姿', width: '10%' },
        { value: 'manifest', text: 'マニフェスト', width: '12%' },
        { value: 'disposal_date', text: '中間処分日\r\n最終処分日', align: 'center', width: '6%' },
        { value: 'editable', text: '編集', align: 'end', width: '5%' },
      ],
      /** 表示順 */
      sortTypes: [
        { value: 'updated_date_desc', text: '更新日（降順）▼' },
        { value: 'updated_date_asc', text: '更新日（昇順）▲' },
        { value: 'carrying_date_desc', text: '受入日（降順）▼' },
        { value: 'carrying_date_asc', text: '受入日（昇順）▲' },
      ],
      acceptances: [],
      rowSelected: [],
      selectedOrderIds: [],
      targetManifestIds: [],
      disposalLocations: [],
      enableWarningDialog: false,
      warningDialogMessage: null,
      selectableSupplierId: null,
      selectableTraderId: null,
      enableWarningDialog2: false,
      warningDialogMessage2: null,
    }
  },
  computed: {
    ...mapState('DriverAcceptance', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
    ...mapState("DriverTenantConfiguration", {
      isRecycling: "use_recycling",
      mode: "mode"
    }),
  },
  watch: {
    /**
     * ステータスボタン変更の監視
     */
    selectedStatus () {
      this.page = 1
      this.rowSelected = null
      this.rowSelected = []
      this.searchAcceptances()
    },
  },
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState()
    }

    this.fetchDisposalLocations().then((content) => {
      this.disposalLocations = null
      this.disposalLocations = []
      for (const disposer of content.disposers) {
        this.disposalLocations.push(disposer.location_hash)
      }
    })
    Object.assign(this.conditions, this.searchCondition);
    this.page = this.pagination.current_page
    this.perPage = this.searchCondition.limit
    this.searchAcceptances()
  },
  methods: {
    ...mapActions('DriverAcceptance', {
      fetchAcceptances: 'index',
      resetState: 'resetState',
      receiveRegister: 'create',
    }),
    ...mapActions('DriverOrderReceiveSummary', {
      fetchSummaries: 'index'
    }),
    ...mapActions('DriverOrderReportConfirmationVerification', {
      verification: 'show',
    }),
    ...mapActions("DriverOrderConfirmationSlipVerification", {
      slipVerification: "show",
    }),
    ...mapActions('DriverMasterSearchTenantDisposerDetail', {
      fetchDisposalLocations: 'index',
    }),
    ...mapActions("DriverAcceptanceDirectlyComplete", {
      directlyComplete: "update"
    }),
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent () {
      this.page = 1
      this.searchAcceptances()
    },
    statusChangeEvent() {
      this.page = 1
      this.rowSelected = null
      this.rowSelected = []
      this.searchAcceptances()
    },
    /**
     * ページ チェンジイベント
     */
    changePage(page) {
      this.page = page;
      this.searchAcceptances()
    },
    changePerPage (perPage) {
      this.perPage = perPage
      this.page = 1
      this.searchAcceptances()
    },
    /**
     * 検索
     * このメソッドではチェック状態をリセットしない
     * ページャ切替時にリセットしない為
     */
    searchAcceptances () {
      this.rowSelected = null
      this.rowSelected = []
      let params = this.buildParam('json')
      this.fetchSummaries().then((content) => {
        this.summaries = content
      })
      this.fetchAcceptances({params: params}).then((content) => {
        this.acceptances = content.orders
      })
    },
    /**
     * CSV出力ボタン クリックイベント
     */
    outputCsvButtonClickEvent () {
      let params = this.buildParam('csv')
      this.fetchAcceptances({params: params}).then((content) => {
        this.downloadCsv(content, '処分場受入')
      })
    },
    buildParam (format) {
      return {
        ...this.conditions,
        page: this.page,
        limit: this.perPage,
        format: format
      }
    },
    emissionDialogButtonClickEvent () {
      this.enableEmissionDialog = true;
    },
    traderDialogButtonClickEvent () {
      this.enableTraderDialog = true;
    },
    /**
     * 受渡確認票出力ボタン クリックイベント
     * @description 受渡確認票を別タブにて表示する
     */
    outputManifestButtonClickEvent () {
      let selectedIds = this.rowSelected.map(v=>v.id)
      const params = {
        targets: selectedIds
      };
      this.slipVerification({ params: params }).then((content) => {
        if (content.status === "success") {
          let resolvedRoute = this.$router.resolve({
            name: 'DriverOrderConfirmationSlips',
            query: { targets: selectedIds, sort_type: this.conditions.sort_type }
          })
          window.open(resolvedRoute.href, '_blank');
        } else {
          this.warningDialogMessage = content.error_message;
          this.enableWarningDialog = true;
        }
      });
    },
    /**
     * 行選択トグル
     */
    toggleRowSelection(item) {
      const index = this.rowSelected.findIndex(row => row === item);
      if (index > -1) {
        // 既に選択されている場合は削除
        this.rowSelected.splice(index, 1);
      } else {
        // 選択されていない場合は追加
        this.rowSelected.push(item);
      }
    },
    /**
     * 詳細を参照メニュー クリックイベント
     * @param item
     */
    showButtonClickEvent (item) {
      this.$router.push({name: 'DriverAcceptance', params: {id: item.id}})
    },
    directlyCompleteButtonClickEvent (item) {
      let modalOption = {
        title: "処分完了登録",
        message: "処分完了に更新します。よろしいですか？",
        options: { width: 450, isCancelButton: true },
      }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.directlyComplete({id: item.id}).then(() => {
            this.rowSelected = null
            this.rowSelected = []
            this.searchAcceptances()
          })
        }
      })
    },
    /**
     * 受入登録ボタン クリックイベント
     */
    receiveRegisterButtonClickEvent () {
      this.selectedOrderIds = this.rowSelected.map(v=>v.id)
      let modalOption = { title: '受入登録', message: '受入登録します。よろしいですか？', options: { titleColor: 'blue' } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          let params = { order_ids: this.selectedOrderIds }
          this.receiveRegister({params: params}).then(() => {
            this.rowSelected = null
            this.rowSelected = []
            this.searchAcceptances()
          })
        }
      })
    },
    /**
     * 処分終了報告ボタン クリックイベント
     */
    disposalReportDialogClickEvent (showRecyclingFields = false) {
      this.showRecyclingFields = showRecyclingFields;
      this.selectedOrderIds = this.rowSelected.map(v=>v.id)
      const params = { ids: this.selectedOrderIds.join(','), report_type: 'disposal', sort_type: this.conditions.sort_type }
      this.warningDialogMessage = null
      this.verification({params: params}).then((content) => {
        if (content.status === 'success') {
          this.targetManifestIds = content.manifest_ids
          this.enableDisposalReportDialog = true
        } else {
          this.warningDialogMessage = content.error_message
          this.enableWarningDialog = true
        }
      })
    },
    /**
     * 処分終了報告 一括登録ボタン クリックイベント
     */
    bulkDisposalReportDialogClickEvent (showRecyclingFields = false) {
      this.showRecyclingFields = showRecyclingFields;
      this.selectedOrderIds = this.rowSelected.map(v=>v.id)
      const params = { ids: this.selectedOrderIds.join(','), report_type: 'disposal', is_bulk: true }
      this.warningDialogMessage = null
      this.verification({params: params}).then((content) => {
        if (content.status === 'success') {
          this.targetManifestIds = content.manifest_ids
          this.enableBulkDisposalReportDialog = true
        } else {
          this.warningDialogMessage = content.error_message
          this.enableWarningDialog = true
        }
      })
    },
    /**
     * 最終処分終了報告ボタン クリックイベント
     */
    finalDisposalReportDialogClickEvent (type = 'default') {
      this.selectedOrderIds = this.rowSelected.map(v=>v.id)
      const params = { ids: this.selectedOrderIds.join(','), report_type: 'final_disposal' }
      this.warningDialogMessage = null
      this.verification({params: params}).then((content) => {
        if (content.status === 'success') {
          this.targetManifestIds = content.manifest_ids
          if (type === 'default') {
            this.enableFinalDisposalReportDialog = true;
          } else {
            this.enableRecycleFinalDisposalReportDialog = true;
          }
        } else {
          this.warningDialogMessage = content.error_message
          this.enableWarningDialog = true
        }
      })
    },
    /**
     * 最終処分終了報告 一括登録ボタン クリックイベント
     */
    bulkFinalDisposalReportDialogClickEvent (type = 'default') {
      this.selectedOrderIds = null
      this.selectedOrderIds = []
      this.selectedOrderIds = this.rowSelected.map(v=>v.id)
      this.targetManifestIds = []

      const params = { ids: this.selectedOrderIds.join(','), report_type: 'final_disposal', is_bulk: true }
      this.warningDialogMessage = null
      this.verification({params: params}).then((content) => {
        if (content.status === 'success') {
          this.targetManifestIds = content.manifest_ids
          if (type === 'default') {
            this.enableBulkFinalDisposalReportDialog = true
          } else{
            /*
 * 選択されたマニフェストの処分場がすべて一致しているかのチェック処理
 * 複数で別々の処分場が選択されてしまうと、異なる処理場で登録された処理フローが選択・登録できてしまうので
 * 必ず同一の処理場のマニフェストが選択されていることを条件に一括モーダルを表示する。
 * 混在している場合はエラーとし、処理を続行させない。
 */
            // const selectedManifests = this.manifests.filter(v => this.targetManifestIds.includes(v.id));

            const selectedOrders = this.acceptances.filter(v => this.selectedOrderIds.includes(v.id));
            const disposerKeys = new Set(
              selectedOrders.map(order => order.disposer_key)
            );
            const hasDiffer = disposerKeys.size > 1;

            if (hasDiffer) {
              this.warningDialogMessage2 = "処分場が異なるマニフェストが選択されています。"
              this.enableWarningDialog2 = true;
            } else {
              this.enableBulkRecycleFinalDisposalReportDialog = true;
            }


            // this.enableBulkRecycleFinalDisposalReportDialog = true;
          }
        } else {
          this.warningDialogMessage = content.error_message
          this.enableWarningDialog = true
        }
      })
    },
    /**
     * ダイアログ 閉じるボタンコールバック
     */
    dialogCloseCallback () {
      this.enableEmissionDialog = false;
      this.enableTraderDialog = false;
      this.enableDisposalReportDialog = false
      this.enableBulkDisposalReportDialog = false
      this.enableFinalDisposalReportDialog = false
      this.enableBulkFinalDisposalReportDialog = false
      this.enableRecycleFinalDisposalReportDialog = false
      this.enableBulkRecycleFinalDisposalReportDialog = false
    },
    editDialogRegisterCallback () {
      this.dialogCloseCallback()
      this.searchAcceptances()
      this.rowSelected = null
      this.rowSelected = []
    },
    /**
     * 排出事業者 チェンジコールバック
     * @param emission_id { Number } 排出事業者ID
     */
    supplierChangedCallback (emission_id) {

      let changed = false;

      if (this.conditions.supplier_id !== emission_id) {
        changed = true;
      }

      this.conditions.supplier_id = emission_id;
      if (changed) {
        this.searchButtonClickEvent();
      }
    },
    /**
     * 排出事業者 選択ボタンからのダイアログのコールバック
     * @param item
     */
     choseSupplierCallback (item) {
      this.conditions.supplier_id = item.id
      this.searchButtonClickEvent();
      this.dialogCloseCallback();
    },
    /**
     * 搬入業者 チェンジコールバック
     * @param trader_id
     */
    traderChangedCallback (trader_id) {

      let changed = false;

      if (this.conditions.trader_id !== trader_id) {
        changed = true;
      }

      this.conditions.trader_id = trader_id;

      if (changed) {
        this.searchButtonClickEvent();
      }

    },
    choseTraderCallback (item) {
      this.conditions.trader_id = item.id;
      this.searchButtonClickEvent();
      this.dialogCloseCallback();
    },
    /**
     * 受入日（from）変更　コールバック
     */
    carryInStartDateChangedCallback (value) {
      this.conditions.carry_in_start_date = value;
      this.searchButtonClickEvent();
    },
    /**
     * 受入日（to）変更　コールバック
     */
    carryInEndDateChangedCallback (value) {
      this.conditions.carry_in_end_date = value;
      this.searchButtonClickEvent();
    },
  }
}
</script>

<style scoped lang="scss">
.panel-header-color {
  color: #0D74BA !important;
  & .v-expansion-panel-header__icon {
    & .v-icon {
      color: #0D74BA !important;
      &::before {
        color: #0D74BA !important;
      }
    }
  }
}
.panel-selectable {
  background-color: #DCE7EB;
}

.selectedCard {
  border-color: red !important;
}
.to-small-font {
  font-size: 85%;
}

.status-card {
  & .image-col {
    padding-top: 0;padding-bottom: 0;
    display: inline-flex;
  }
  & .status-col {
    padding-left: 0;padding-right: 0;
  }
}

.v-tooltip__content {
  opacity: 1!important;
  background-color: #ffffff !important;
  border: 1px solid #dddddd !important;
  color: #565656 !important;
}
</style>
